import { useCallback } from "react";
import { fetchQuery, useQueryLoader, useRelayEnvironment } from "react-relay";
import { WIDGET_EMPLOYEE_SCHEDULE_PREVIEW_QUERY } from "./WidgetEmployeeSchedulePreview";
import { useFocusEffect } from "@react-navigation/native";
import { useDebouncedCallback } from "use-debounce";
import {
  WidgetEmployeeSchedulePreviewQuery,
  WidgetEmployeeSchedulePreviewQuery$variables,
} from "./__generated__/WidgetEmployeeSchedulePreviewQuery.graphql";

export function useWidgetEmployeeSchedulePreviewQueryLoader({
  storecastId,
  teamIds,
}: {
  storecastId: string;
  teamIds: string[];
}) {
  const [query, loadQuery] = useQueryLoader<WidgetEmployeeSchedulePreviewQuery>(
    WIDGET_EMPLOYEE_SCHEDULE_PREVIEW_QUERY
  );

  const environment = useRelayEnvironment();
  const loadPreviewQuery = useDebouncedCallback(
    async (newTeamIds: string[]) => {
      try {
        const variables: WidgetEmployeeSchedulePreviewQuery$variables = {
          storecastId,
          input: {
            size: "TWO_X_FOUR",
            teamIds: newTeamIds.length === 0 ? null : newTeamIds,
          },
        };
        await fetchQuery(
          environment,
          WIDGET_EMPLOYEE_SCHEDULE_PREVIEW_QUERY,
          variables
        ).toPromise();
        loadQuery(variables);
      } catch {}
    },
    300
  );
  useFocusEffect(
    useCallback(() => {
      loadPreviewQuery(teamIds);
    }, [teamIds, loadPreviewQuery])
  );
  return query;
}
